import { render, staticRenderFns } from "./XmlPage.vue?vue&type=template&id=19a249c4&scoped=true&"
import script from "./XmlPage.vue?vue&type=script&lang=js&"
export * from "./XmlPage.vue?vue&type=script&lang=js&"
import style0 from "./XmlPage.vue?vue&type=style&index=0&id=19a249c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a249c4",
  null
  
)

export default component.exports